import { render, staticRenderFns } from "./change-password-modal.vue?vue&type=template&id=dc79fd4e&scoped=true&"
import script from "./change-password-modal.vue?vue&type=script&lang=js&"
export * from "./change-password-modal.vue?vue&type=script&lang=js&"
import style0 from "./change-password-modal.vue?vue&type=style&index=0&id=dc79fd4e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc79fd4e",
  null
  
)

export default component.exports